import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { validateZipCode } from '../../api/quoteApi';

export const verifyCp  = createAsyncThunk(
    'driver/verifyCp', 
    async ({ zipCode }, { rejectWithValue }) => {
      try {
          return await validateZipCode({ zipCode });
      } catch (error) {
          return rejectWithValue(error.message);
      }
    }
);

const initialState = {

  formValues: {
    nombres: '',
    primerApellido: '',
    segundoApellido: '',
    genero: '',
    fechaNacimiento: '',
    codigoPostal: ''
  },

  validValues: {
    nombres: true,
    primerApellido: false,
    segundoApellido: false,
    genero: false,
    fechaNacimiento: false,
    codigoPostal: false
  },

  errors: {},
};

const driverSlice = createSlice({
  name: 'driver',
  initialState,
  reducers: {
        setFormValue: (state, action) => {
          const { field, value } = action.payload;
          state.formValues[field] = value;
        },
        setValidValue: (state, action) => {
          const { field, isValid } = action.payload;
          state.validValues[field] = isValid;
        },
        setFieldError: (state, action) => {
          const { field, error } = action.payload;
          state.errors[field] = error;
        },
        resetForm: (state) => {
          state.formValues = initialState.formValues;
          state.validValues = initialState.validValues;
        }
    },
    extraReducers: (builder) => {
      builder
        .addCase(verifyCp.fulfilled, (state, action) => {
          state.validValues.codigoPostal = action.payload.isValid;
        })
        .addCase(verifyCp.rejected, (state) => {
          state.validValues.codigoPostal = false;
        });
    }
});

export const { 
  setFormValue,
  setValidValue,
  resetError, 
  resetForm
} = driverSlice.actions;
export default driverSlice.reducer;